import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const ColleagueWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="colleagueWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="colleagueWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="colleagueWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="colleagueWriterFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.format?.message}
      />
      <FormField
        controlId="colleagueWriterFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>
      <FormField
        controlId="colleagueWriterFormUrl"
        label="url"
        name="properties.url"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter URL"
        required
        error={errors.properties?.url?.message}
      />
      <FormField
        controlId="colleagueWriterFormDetailedResponse"
        label="detailedResponse"
        name="properties.detailedResponse"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.detailedResponse?.message}
      />
      <FormField
        controlId="colleagueWriterFormHttpMethod"
        label="httpMethod"
        name="properties.httpMethod"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        placeholder="Enter HTTP method"
        required
        error={errors.properties?.httpMethod?.message}
      >
        <option value="">Select HTTP Method</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
      </FormField>
      <FormField
        controlId="colleagueWriterFormHeaders"
        label="headers"
        name="properties.headers"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        rows={10}
        error={errors.properties?.headers?.message}
      />
      <FormField
        controlId="colleagueWriterFormHeadersJson"
        label="headersJson"
        name="properties.headersJson"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.JSON}
        rows={10}
        error={errors.properties?.headersJson?.message}
      />
      <FormField
        controlId="colleagueWriterFormInputTemplateRef"
        label="inputTemplateRef"
        name="properties.inputTemplateRef"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.inputTemplateRef?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default ColleagueWriterForm;
